// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton[data-v-5db31820] {\r\n  margin-left: 5px;\n}\n.ant-btn-danger[data-v-5db31820] {\r\n  background: rgba(204, 204, 204, 0.2);\r\n  border: 1px solid #ccc;\r\n  color: #ccc;\n}\n.ant-btn-primary[data-v-5db31820] {\r\n  background: rgba(3, 122, 129, 0.2);\r\n  border: 1px solid #037a81;\r\n  color: #037a81;\n}\r\n", ""]);
// Exports
module.exports = exports;
